/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum MeterLevelCategoriesEnum {
    CONSUMPTION = 'CONSUMPTION',
    CHARGE = 'CHARGE',
    DELIVERY = 'DELIVERY',
    TAX = 'TAX',
    METER = 'METER',
}
